import type { CoreStoreType } from '../../../store/CoreStore';
import type { GameCommunicationSenderType } from '../types';

import { GameCommunicationBaseSender } from './GameCommunicationBaseSender';

export class GameCommunicationBetSender extends GameCommunicationBaseSender {
  name = 'Bet';

  send(_: never, store: CoreStoreType, sender: GameCommunicationSenderType, additionalParam?: string): void {
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const gameId = state.gameState.gameId;
    const userId = state.config.playerConfig?.userId;
    const betStack = state.bets.betStack;
    const gameName = state.config.session?.gametype;

    const bets = betStack[betStack.length - 1]?.betSpots || {};

    const betTime = Date.now();
    const betTags = Object.keys(bets).reduce((acc, betSpot) => {
      if (bets[betSpot].value > 0) {
        return acc + `<bet amt="${bets[betSpot].value}" bc="${betSpot}" ck="${betTime}"/>`;
      }
      return acc;
    }, '');

    if (gameChannel && userId) {
      let message = '';
      message += `<command channel="${gameChannel}">`;
      message += `<lpbet gm="${gameName}" gId="${gameId}" uId="${userId}" ck="${Date.now()}" ${additionalParam ?? ''}>`;
      message += betTags;
      message += '</lpbet>';
      message += '</command>';

      sender?.(message);
    }
  }
}
